import Highcharts from 'highcharts';
import { theme } from '../../../theme/theme';
import { formatPercentage } from '../../../CommonUtils/formatNumber';

// Restore pre-v11 legend symbols (dots instead of lines).
Highcharts.setOptions({
  plotOptions: {
    series: {
      legendSymbol: 'rectangle',
    },
  },
});

export type AxisType = 'decimal' | 'datetime' | 'percentage' | 'currency' | 'category';

export const SERIES_COLORS = [
  '#0078D4',
  '#7EC4F6',
  '#9061F9',
  '#CABFFD',
  '#0E9F6E',
  '#84E1BC',
  '#EB6A37',
  '#FDBA8C',
  '#EF4268',
  '#FEAEB6',
];

export const axisSettings = {
  decimal: {},

  datetime: {
    type: 'datetime',
    dateTimeLabelFormats: {
      millisecond: '%H:%M:%S.%L',
      second: '%H:%M:%S',
      minute: '%H:%M',
      hour: '%H:%M',
      day: '%b %e',
      week: '%b %e',
      month: '%b %Y',
      year: '%Y',
    },
  },

  percentage: {
    labels: {
      formatter() {
        return formatPercentage(this.value, {
          mantissa: 2,
          average: true,
        }).toUpperCase();
      },
    },
  },

  currency: {
    labels: {
      formatter() {
        const formattedCurrency = (this as any).axis.defaultLabelFormatter.call(this);

        return `${
          formattedCurrency[0] === '-'
            ? `-$${formattedCurrency.substring(1)}`
            : `$${formattedCurrency}`
        }`;
      },
    },
  },

  category: {
    type: 'category',
  },
};

export const commonSettings: Highcharts.Options = {
  title: {
    text: '',
  },

  legend: {
    align: 'center',
    verticalAlign: 'bottom',
    symbolRadius: 6,
    symbolWidth: 12,
    squareSymbol: true,
    itemStyle: {
      fontFamily: theme.fontFamily,
      fontWeight: '500',
      color: theme.colors.neutral['700'],
    },
  },

  tooltip: {
    backgroundColor: theme.colors.neutral['700'],
    borderColor: theme.colors.neutral['700'],
    borderRadius: theme.radii.medium,
    shadow: false,
    shape: 'rect',
    useHTML: true,
    style: {
      color: theme.colors.neutral['100'],
    },
  },

  colors: SERIES_COLORS,

  plotOptions: {
    series: {
      legendSymbol: 'rectangle',
    },
  },

  credits: {
    enabled: false,
  },

  exporting: {
    enabled: false,
  },

  xAxis: {
    gridLineWidth: 0,
    tickWidth: 0,
    lineWidth: 0,
    labels: {
      style: {
        fontSize: `${theme.fontSizes.small}px`,
        color: theme.colors.neutral['500'],
        fontWeight: '500',
      },
    },
  },

  yAxis: {
    title: {
      text: '',
    },
    gridLineColor: theme.colors.neutral['100'],
    gridLineDashStyle: 'Solid',
    gridLineWidth: 1,
    labels: {
      style: {
        fontFamily: theme.fontFamily,
        fontSize: `${theme.fontSizes.small}px`,
        color: theme.colors.neutral['500'],
        fontWeight: '500',
      },
    },
  },
};

export const CURVE = [2, 4.52, 3.96, 3.69, 6.09, 5.6, 6.5, 6.67, 6.5, 7.69, 7.63, 6.67, 8.05];
